/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} These_Jumpy_Clownfish_ChopInputs */

const fr_these_jumpy_clownfish_chop = /** @type {(inputs: These_Jumpy_Clownfish_ChopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déconnexion`)
};

/**

* @param {These_Jumpy_Clownfish_ChopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const these_jumpy_clownfish_chop = /** @type {((inputs?: These_Jumpy_Clownfish_ChopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<These_Jumpy_Clownfish_ChopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_these_jumpy_clownfish_chop(inputs)
});